export default __webpack_public_path__ + "static/media/close.ab87035c.svg";